/* eslint-disable */
import React, { useContext, useState } from 'react';
import { Row, Col, Modal, Button } from 'react-bootstrap';
import { Context } from 'context/AuthContext';
import Summary from '../../../components/Summary';
import TitlePages from 'components/_base/TitlePages';
import { ADD_ASSUMIR_DIAGRAMACAO, GET_LIST_DEMANDA } from 'services/Demanda';
import { useParams, useHistory } from 'react-router-dom';

import './styles.scss';

const ContentBalcaoDemanda = (props) => {
  const params = useParams();
  const history = useHistory();

  //let solicitacaoId = 64098;
  let updateIsOwner = false;

  const solicitacaoId = params.solicitacaoId || 0;

  const { showLoader } = useContext(Context);

  const [modal, setModal] = useState({
    ativo: false,
    demandaId: null, // Numero da solicitacao da demanda
  });

  async function pegarDemandaClick(solicitacaoId) {
    showLoader(true);

    setModal({ ativo: false, demandaId: null });

    const params = {
      usuarioId: 0,
      solicitacaoId: solicitacaoId,
    };

    const data = await ADD_ASSUMIR_DIAGRAMACAO(params);

    if (200 === data.code) {
      const data = await GET_LIST_DEMANDA({});
      //setDemandas(data.value);
    }

    showLoader(false);

    history.push({ pathname: '/pendencias' });
  }

  function ModalAssumirDemanda() {
    return (
      <Modal
        show={modal.ativo}
        onHide={() => setModal({ ativo: !modal.ativo, demandaId: null })}
        className="modal-discard-draft"
      >
        <Modal.Body>
          <h3>
            Tem certeza que deseja assumir a demanda da solicitacção n°{' '}
            {solicitacaoId} ?
          </h3>
          <p>
            Ao clicar em "Assumir", uma pendência será criada para você. Deseja
            continuar?
          </p>
          <Row className="buttons">
            <Col className="text-center">
              <Button
                variant="secondary"
                onClick={() =>
                  setModal({ ativo: !modal.ativo, pendenciaId: null })
                }
                className="button"
              >
                Cancelar
              </Button>
            </Col>
            <Col className="text-center">
              <Button
                variant="danger"
                onClick={() => pegarDemandaClick(solicitacaoId)}
                className="button"
              >
                Assumir
              </Button>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    );
  }

  return (
    <div className="wrapper-balcao-demanda">
      <TitlePages title="Resumo da Demanda" />
      <div className="content">
        <Summary solicitacaoId={solicitacaoId} updateIsOwner={updateIsOwner} />
      </div>
      <hr></hr>
      <div className="button-bar">
        <Button className="button-action">
          <a href="/">Cancelar</a>
        </Button>
        <Button
          className="button-action"
          onClick={() =>
            setModal({
              ativo: true,
              demandaid: solicitacaoId,
            })
          }
        >
          Assumir
        </Button>
      </div>

      {ModalAssumirDemanda()}
    </div>
  );
};

export default ContentBalcaoDemanda;
